import { Grid } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCardSkeleton from '../../components/section-card/SectionCardSkeleton'
import { useCardSkeletonColumns } from '../useSingleOrDoubleColumns'
import VitalsLoading from './VitalsLoading'

type Props = {
  isSingleCardPage?: boolean
  totalColumns?: number
}

export default function VitalsCardSkeleton({ isSingleCardPage = true, totalColumns = 12 }: Props): JSX.Element {
  const [t] = useTranslation()
  const columns = useCardSkeletonColumns(totalColumns)

  return (
    <Grid gutters="nano">
      <SectionCardSkeleton isSingleCardPage={isSingleCardPage} heading={t('tree-person.vitals.label')}>
        <VitalsLoading columns={columns} />
      </SectionCardSkeleton>
    </Grid>
  )
}
